/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type MultiUserGroupAssignmentCreate,
    MultiUserGroupAssignmentCreateFromJSON,
    MultiUserGroupAssignmentCreateToJSON,
} from '../models/MultiUserGroupAssignmentCreate';
import {
    type PageInfo,
    PageInfoFromJSON,
    PageInfoToJSON,
} from '../models/PageInfo';
import {
    type SortDirection,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/SortDirection';
import {
    type UserGroupAssignment,
    UserGroupAssignmentFromJSON,
    UserGroupAssignmentToJSON,
} from '../models/UserGroupAssignment';
import {
    type UserGroupAssignmentCreate,
    UserGroupAssignmentCreateFromJSON,
    UserGroupAssignmentCreateToJSON,
} from '../models/UserGroupAssignmentCreate';
import {
    type UserGroupAssignmentSortKey,
    UserGroupAssignmentSortKeyFromJSON,
    UserGroupAssignmentSortKeyToJSON,
} from '../models/UserGroupAssignmentSortKey';
import {
    type UserGroupAssignmentUpdate,
    UserGroupAssignmentUpdateFromJSON,
    UserGroupAssignmentUpdateToJSON,
} from '../models/UserGroupAssignmentUpdate';

export interface UserGroupAssignmentsCreateMultipleUserGroupAssignmentsRequest {
    multiUserGroupAssignmentCreate: MultiUserGroupAssignmentCreate;
}

export interface UserGroupAssignmentsCreateUserGroupAssignmentRequest {
    userGroupAssignmentCreate: UserGroupAssignmentCreate;
}

export interface UserGroupAssignmentsDeleteUserGroupAssignmentRequest {
    userGroupAssignmentId: string;
}

export interface UserGroupAssignmentsListUserGroupAssignmentsRequest {
    pageSize: number;
    userId?: string | null;
    userGroupIds?: Array<string> | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: UserGroupAssignmentSortKey;
}

export interface UserGroupAssignmentsListUserGroupAssignmentsMetadataRequest {
    pageSize: number;
    userId?: string | null;
    userGroupIds?: Array<string> | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: UserGroupAssignmentSortKey;
}

export interface UserGroupAssignmentsReadUserGroupAssignmentRequest {
    userGroupAssignmentId: string;
}

export interface UserGroupAssignmentsUpdateUserGroupAssignmentRequest {
    userGroupAssignmentId: string;
    userGroupAssignmentUpdate: UserGroupAssignmentUpdate;
}

export interface UserGroupAssignmentsValidateCreateUserGroupAssignmentRequest {
    userGroupAssignmentCreate: UserGroupAssignmentCreate;
}

export interface UserGroupAssignmentsValidateUpdateUserGroupAssignmentRequest {
    userGroupAssignmentId: string;
    userGroupAssignmentUpdate: UserGroupAssignmentUpdate;
}

/**
 * UserGroupAssignmentsApi - interface
 * 
 * @export
 * @interface UserGroupAssignmentsApiInterface
 */
export interface UserGroupAssignmentsApiInterface {
    /**
     * Creates request options for userGroupAssignmentsCreateMultipleUserGroupAssignments without sending the request
     * @param {MultiUserGroupAssignmentCreate} multiUserGroupAssignmentCreate 
     * @throws {RequiredError}
     * @memberof UserGroupAssignmentsApiInterface
     */
    userGroupAssignmentsCreateMultipleUserGroupAssignmentsRequestOpts(requestParameters: UserGroupAssignmentsCreateMultipleUserGroupAssignmentsRequest): Promise<runtime.RequestOpts>;

    /**
     * This endpoint accepts a list of User ids and `UserGroup` ids respectively.  Assignments are then created for each `User` to each `UserGroup`. Trying to create duplicate assignments won\'t lead to errors and will simply be ignored.
     * @summary Create multiple `UserGroupAssignment`s
     * @param {MultiUserGroupAssignmentCreate} multiUserGroupAssignmentCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupAssignmentsApiInterface
     */
    userGroupAssignmentsCreateMultipleUserGroupAssignmentsRaw(requestParameters: UserGroupAssignmentsCreateMultipleUserGroupAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserGroupAssignment>>>;

    /**
     * This endpoint accepts a list of User ids and `UserGroup` ids respectively.  Assignments are then created for each `User` to each `UserGroup`. Trying to create duplicate assignments won\'t lead to errors and will simply be ignored.
     * Create multiple `UserGroupAssignment`s
     */
    userGroupAssignmentsCreateMultipleUserGroupAssignments(requestParameters: UserGroupAssignmentsCreateMultipleUserGroupAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserGroupAssignment>>;

    /**
     * Creates request options for userGroupAssignmentsCreateUserGroupAssignment without sending the request
     * @param {UserGroupAssignmentCreate} userGroupAssignmentCreate 
     * @throws {RequiredError}
     * @memberof UserGroupAssignmentsApiInterface
     */
    userGroupAssignmentsCreateUserGroupAssignmentRequestOpts(requestParameters: UserGroupAssignmentsCreateUserGroupAssignmentRequest): Promise<runtime.RequestOpts>;

    /**
     * Create a new user group assignment.
     * @summary Create a user group assignment
     * @param {UserGroupAssignmentCreate} userGroupAssignmentCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupAssignmentsApiInterface
     */
    userGroupAssignmentsCreateUserGroupAssignmentRaw(requestParameters: UserGroupAssignmentsCreateUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserGroupAssignment>>;

    /**
     * Create a new user group assignment.
     * Create a user group assignment
     */
    userGroupAssignmentsCreateUserGroupAssignment(requestParameters: UserGroupAssignmentsCreateUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserGroupAssignment>;

    /**
     * Creates request options for userGroupAssignmentsDeleteUserGroupAssignment without sending the request
     * @param {string} userGroupAssignmentId 
     * @throws {RequiredError}
     * @memberof UserGroupAssignmentsApiInterface
     */
    userGroupAssignmentsDeleteUserGroupAssignmentRequestOpts(requestParameters: UserGroupAssignmentsDeleteUserGroupAssignmentRequest): Promise<runtime.RequestOpts>;

    /**
     * Delete the user group assignment with the given ID.
     * @summary Delete a user group assignment
     * @param {string} userGroupAssignmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupAssignmentsApiInterface
     */
    userGroupAssignmentsDeleteUserGroupAssignmentRaw(requestParameters: UserGroupAssignmentsDeleteUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete the user group assignment with the given ID.
     * Delete a user group assignment
     */
    userGroupAssignmentsDeleteUserGroupAssignment(requestParameters: UserGroupAssignmentsDeleteUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for userGroupAssignmentsListUserGroupAssignments without sending the request
     * @param {number} pageSize 
     * @param {string} [userId] 
     * @param {Array<string>} [userGroupIds] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {UserGroupAssignmentSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof UserGroupAssignmentsApiInterface
     */
    userGroupAssignmentsListUserGroupAssignmentsRequestOpts(requestParameters: UserGroupAssignmentsListUserGroupAssignmentsRequest): Promise<runtime.RequestOpts>;

    /**
     * Lists all the user group assignment present.
     * @summary List user group assignment
     * @param {number} pageSize 
     * @param {string} [userId] 
     * @param {Array<string>} [userGroupIds] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {UserGroupAssignmentSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupAssignmentsApiInterface
     */
    userGroupAssignmentsListUserGroupAssignmentsRaw(requestParameters: UserGroupAssignmentsListUserGroupAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserGroupAssignment>>>;

    /**
     * Lists all the user group assignment present.
     * List user group assignment
     */
    userGroupAssignmentsListUserGroupAssignments(requestParameters: UserGroupAssignmentsListUserGroupAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserGroupAssignment>>;

    /**
     * Creates request options for userGroupAssignmentsListUserGroupAssignmentsMetadata without sending the request
     * @param {number} pageSize 
     * @param {string} [userId] 
     * @param {Array<string>} [userGroupIds] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {UserGroupAssignmentSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof UserGroupAssignmentsApiInterface
     */
    userGroupAssignmentsListUserGroupAssignmentsMetadataRequestOpts(requestParameters: UserGroupAssignmentsListUserGroupAssignmentsMetadataRequest): Promise<runtime.RequestOpts>;

    /**
     * Fetch information about the total amount of pages available.
     * @summary User Group Assignment listing metadata
     * @param {number} pageSize 
     * @param {string} [userId] 
     * @param {Array<string>} [userGroupIds] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {UserGroupAssignmentSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupAssignmentsApiInterface
     */
    userGroupAssignmentsListUserGroupAssignmentsMetadataRaw(requestParameters: UserGroupAssignmentsListUserGroupAssignmentsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>>;

    /**
     * Fetch information about the total amount of pages available.
     * User Group Assignment listing metadata
     */
    userGroupAssignmentsListUserGroupAssignmentsMetadata(requestParameters: UserGroupAssignmentsListUserGroupAssignmentsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo>;

    /**
     * Creates request options for userGroupAssignmentsReadUserGroupAssignment without sending the request
     * @param {string} userGroupAssignmentId 
     * @throws {RequiredError}
     * @memberof UserGroupAssignmentsApiInterface
     */
    userGroupAssignmentsReadUserGroupAssignmentRequestOpts(requestParameters: UserGroupAssignmentsReadUserGroupAssignmentRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the user group assignment specified by the given ID.
     * @summary Get a single user group assignment
     * @param {string} userGroupAssignmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupAssignmentsApiInterface
     */
    userGroupAssignmentsReadUserGroupAssignmentRaw(requestParameters: UserGroupAssignmentsReadUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserGroupAssignment>>;

    /**
     * Returns the user group assignment specified by the given ID.
     * Get a single user group assignment
     */
    userGroupAssignmentsReadUserGroupAssignment(requestParameters: UserGroupAssignmentsReadUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserGroupAssignment>;

    /**
     * Creates request options for userGroupAssignmentsUpdateUserGroupAssignment without sending the request
     * @param {string} userGroupAssignmentId 
     * @param {UserGroupAssignmentUpdate} userGroupAssignmentUpdate 
     * @throws {RequiredError}
     * @memberof UserGroupAssignmentsApiInterface
     */
    userGroupAssignmentsUpdateUserGroupAssignmentRequestOpts(requestParameters: UserGroupAssignmentsUpdateUserGroupAssignmentRequest): Promise<runtime.RequestOpts>;

    /**
     * Update the user group assignment specified by the given ID.
     * @summary Update user group assignment
     * @param {string} userGroupAssignmentId 
     * @param {UserGroupAssignmentUpdate} userGroupAssignmentUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupAssignmentsApiInterface
     */
    userGroupAssignmentsUpdateUserGroupAssignmentRaw(requestParameters: UserGroupAssignmentsUpdateUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserGroupAssignment>>;

    /**
     * Update the user group assignment specified by the given ID.
     * Update user group assignment
     */
    userGroupAssignmentsUpdateUserGroupAssignment(requestParameters: UserGroupAssignmentsUpdateUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserGroupAssignment>;

    /**
     * Creates request options for userGroupAssignmentsValidateCreateUserGroupAssignment without sending the request
     * @param {UserGroupAssignmentCreate} userGroupAssignmentCreate 
     * @throws {RequiredError}
     * @memberof UserGroupAssignmentsApiInterface
     */
    userGroupAssignmentsValidateCreateUserGroupAssignmentRequestOpts(requestParameters: UserGroupAssignmentsValidateCreateUserGroupAssignmentRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for a new user group assignment without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate a user group assignment
     * @param {UserGroupAssignmentCreate} userGroupAssignmentCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupAssignmentsApiInterface
     */
    userGroupAssignmentsValidateCreateUserGroupAssignmentRaw(requestParameters: UserGroupAssignmentsValidateCreateUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for a new user group assignment without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a user group assignment
     */
    userGroupAssignmentsValidateCreateUserGroupAssignment(requestParameters: UserGroupAssignmentsValidateCreateUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for userGroupAssignmentsValidateUpdateUserGroupAssignment without sending the request
     * @param {string} userGroupAssignmentId 
     * @param {UserGroupAssignmentUpdate} userGroupAssignmentUpdate 
     * @throws {RequiredError}
     * @memberof UserGroupAssignmentsApiInterface
     */
    userGroupAssignmentsValidateUpdateUserGroupAssignmentRequestOpts(requestParameters: UserGroupAssignmentsValidateUpdateUserGroupAssignmentRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for updating the given user group assignment, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate user group assignment update
     * @param {string} userGroupAssignmentId 
     * @param {UserGroupAssignmentUpdate} userGroupAssignmentUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupAssignmentsApiInterface
     */
    userGroupAssignmentsValidateUpdateUserGroupAssignmentRaw(requestParameters: UserGroupAssignmentsValidateUpdateUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for updating the given user group assignment, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate user group assignment update
     */
    userGroupAssignmentsValidateUpdateUserGroupAssignment(requestParameters: UserGroupAssignmentsValidateUpdateUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class UserGroupAssignmentsApi extends runtime.BaseAPI implements UserGroupAssignmentsApiInterface {

    /**
     * Creates request options for userGroupAssignmentsCreateMultipleUserGroupAssignments without sending the request
     */
    async userGroupAssignmentsCreateMultipleUserGroupAssignmentsRequestOpts(requestParameters: UserGroupAssignmentsCreateMultipleUserGroupAssignmentsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['multiUserGroupAssignmentCreate'] == null) {
            throw new runtime.RequiredError(
                'multiUserGroupAssignmentCreate',
                'Required parameter "multiUserGroupAssignmentCreate" was null or undefined when calling userGroupAssignmentsCreateMultipleUserGroupAssignments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user_group_assignments/multi`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MultiUserGroupAssignmentCreateToJSON(requestParameters['multiUserGroupAssignmentCreate']),
        };
    }

    /**
     * This endpoint accepts a list of User ids and `UserGroup` ids respectively.  Assignments are then created for each `User` to each `UserGroup`. Trying to create duplicate assignments won\'t lead to errors and will simply be ignored.
     * Create multiple `UserGroupAssignment`s
     */
    async userGroupAssignmentsCreateMultipleUserGroupAssignmentsRaw(requestParameters: UserGroupAssignmentsCreateMultipleUserGroupAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserGroupAssignment>>> {
        const requestOptions = await this.userGroupAssignmentsCreateMultipleUserGroupAssignmentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserGroupAssignmentFromJSON));
    }

    /**
     * This endpoint accepts a list of User ids and `UserGroup` ids respectively.  Assignments are then created for each `User` to each `UserGroup`. Trying to create duplicate assignments won\'t lead to errors and will simply be ignored.
     * Create multiple `UserGroupAssignment`s
     */
    async userGroupAssignmentsCreateMultipleUserGroupAssignments(requestParameters: UserGroupAssignmentsCreateMultipleUserGroupAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserGroupAssignment>> {
        const response = await this.userGroupAssignmentsCreateMultipleUserGroupAssignmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for userGroupAssignmentsCreateUserGroupAssignment without sending the request
     */
    async userGroupAssignmentsCreateUserGroupAssignmentRequestOpts(requestParameters: UserGroupAssignmentsCreateUserGroupAssignmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userGroupAssignmentCreate'] == null) {
            throw new runtime.RequiredError(
                'userGroupAssignmentCreate',
                'Required parameter "userGroupAssignmentCreate" was null or undefined when calling userGroupAssignmentsCreateUserGroupAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user_group_assignments/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserGroupAssignmentCreateToJSON(requestParameters['userGroupAssignmentCreate']),
        };
    }

    /**
     * Create a new user group assignment.
     * Create a user group assignment
     */
    async userGroupAssignmentsCreateUserGroupAssignmentRaw(requestParameters: UserGroupAssignmentsCreateUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserGroupAssignment>> {
        const requestOptions = await this.userGroupAssignmentsCreateUserGroupAssignmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserGroupAssignmentFromJSON(jsonValue));
    }

    /**
     * Create a new user group assignment.
     * Create a user group assignment
     */
    async userGroupAssignmentsCreateUserGroupAssignment(requestParameters: UserGroupAssignmentsCreateUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserGroupAssignment> {
        const response = await this.userGroupAssignmentsCreateUserGroupAssignmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for userGroupAssignmentsDeleteUserGroupAssignment without sending the request
     */
    async userGroupAssignmentsDeleteUserGroupAssignmentRequestOpts(requestParameters: UserGroupAssignmentsDeleteUserGroupAssignmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userGroupAssignmentId'] == null) {
            throw new runtime.RequiredError(
                'userGroupAssignmentId',
                'Required parameter "userGroupAssignmentId" was null or undefined when calling userGroupAssignmentsDeleteUserGroupAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user_group_assignments/{user_group_assignment_id}`;
        urlPath = urlPath.replace('{user_group_assignment_id}', encodeURIComponent(String(requestParameters['userGroupAssignmentId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete the user group assignment with the given ID.
     * Delete a user group assignment
     */
    async userGroupAssignmentsDeleteUserGroupAssignmentRaw(requestParameters: UserGroupAssignmentsDeleteUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.userGroupAssignmentsDeleteUserGroupAssignmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the user group assignment with the given ID.
     * Delete a user group assignment
     */
    async userGroupAssignmentsDeleteUserGroupAssignment(requestParameters: UserGroupAssignmentsDeleteUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userGroupAssignmentsDeleteUserGroupAssignmentRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for userGroupAssignmentsListUserGroupAssignments without sending the request
     */
    async userGroupAssignmentsListUserGroupAssignmentsRequestOpts(requestParameters: UserGroupAssignmentsListUserGroupAssignmentsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling userGroupAssignmentsListUserGroupAssignments().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['user_id'] = requestParameters['userId'];
        }

        if (requestParameters['userGroupIds'] != null) {
            queryParameters['user_group_ids'] = requestParameters['userGroupIds'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user_group_assignments/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists all the user group assignment present.
     * List user group assignment
     */
    async userGroupAssignmentsListUserGroupAssignmentsRaw(requestParameters: UserGroupAssignmentsListUserGroupAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserGroupAssignment>>> {
        const requestOptions = await this.userGroupAssignmentsListUserGroupAssignmentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserGroupAssignmentFromJSON));
    }

    /**
     * Lists all the user group assignment present.
     * List user group assignment
     */
    async userGroupAssignmentsListUserGroupAssignments(requestParameters: UserGroupAssignmentsListUserGroupAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserGroupAssignment>> {
        const response = await this.userGroupAssignmentsListUserGroupAssignmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for userGroupAssignmentsListUserGroupAssignmentsMetadata without sending the request
     */
    async userGroupAssignmentsListUserGroupAssignmentsMetadataRequestOpts(requestParameters: UserGroupAssignmentsListUserGroupAssignmentsMetadataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling userGroupAssignmentsListUserGroupAssignmentsMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['user_id'] = requestParameters['userId'];
        }

        if (requestParameters['userGroupIds'] != null) {
            queryParameters['user_group_ids'] = requestParameters['userGroupIds'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user_group_assignments/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch information about the total amount of pages available.
     * User Group Assignment listing metadata
     */
    async userGroupAssignmentsListUserGroupAssignmentsMetadataRaw(requestParameters: UserGroupAssignmentsListUserGroupAssignmentsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>> {
        const requestOptions = await this.userGroupAssignmentsListUserGroupAssignmentsMetadataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageInfoFromJSON(jsonValue));
    }

    /**
     * Fetch information about the total amount of pages available.
     * User Group Assignment listing metadata
     */
    async userGroupAssignmentsListUserGroupAssignmentsMetadata(requestParameters: UserGroupAssignmentsListUserGroupAssignmentsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo> {
        const response = await this.userGroupAssignmentsListUserGroupAssignmentsMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for userGroupAssignmentsReadUserGroupAssignment without sending the request
     */
    async userGroupAssignmentsReadUserGroupAssignmentRequestOpts(requestParameters: UserGroupAssignmentsReadUserGroupAssignmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userGroupAssignmentId'] == null) {
            throw new runtime.RequiredError(
                'userGroupAssignmentId',
                'Required parameter "userGroupAssignmentId" was null or undefined when calling userGroupAssignmentsReadUserGroupAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user_group_assignments/{user_group_assignment_id}`;
        urlPath = urlPath.replace('{user_group_assignment_id}', encodeURIComponent(String(requestParameters['userGroupAssignmentId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the user group assignment specified by the given ID.
     * Get a single user group assignment
     */
    async userGroupAssignmentsReadUserGroupAssignmentRaw(requestParameters: UserGroupAssignmentsReadUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserGroupAssignment>> {
        const requestOptions = await this.userGroupAssignmentsReadUserGroupAssignmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserGroupAssignmentFromJSON(jsonValue));
    }

    /**
     * Returns the user group assignment specified by the given ID.
     * Get a single user group assignment
     */
    async userGroupAssignmentsReadUserGroupAssignment(requestParameters: UserGroupAssignmentsReadUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserGroupAssignment> {
        const response = await this.userGroupAssignmentsReadUserGroupAssignmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for userGroupAssignmentsUpdateUserGroupAssignment without sending the request
     */
    async userGroupAssignmentsUpdateUserGroupAssignmentRequestOpts(requestParameters: UserGroupAssignmentsUpdateUserGroupAssignmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userGroupAssignmentId'] == null) {
            throw new runtime.RequiredError(
                'userGroupAssignmentId',
                'Required parameter "userGroupAssignmentId" was null or undefined when calling userGroupAssignmentsUpdateUserGroupAssignment().'
            );
        }

        if (requestParameters['userGroupAssignmentUpdate'] == null) {
            throw new runtime.RequiredError(
                'userGroupAssignmentUpdate',
                'Required parameter "userGroupAssignmentUpdate" was null or undefined when calling userGroupAssignmentsUpdateUserGroupAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user_group_assignments/{user_group_assignment_id}`;
        urlPath = urlPath.replace('{user_group_assignment_id}', encodeURIComponent(String(requestParameters['userGroupAssignmentId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UserGroupAssignmentUpdateToJSON(requestParameters['userGroupAssignmentUpdate']),
        };
    }

    /**
     * Update the user group assignment specified by the given ID.
     * Update user group assignment
     */
    async userGroupAssignmentsUpdateUserGroupAssignmentRaw(requestParameters: UserGroupAssignmentsUpdateUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserGroupAssignment>> {
        const requestOptions = await this.userGroupAssignmentsUpdateUserGroupAssignmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserGroupAssignmentFromJSON(jsonValue));
    }

    /**
     * Update the user group assignment specified by the given ID.
     * Update user group assignment
     */
    async userGroupAssignmentsUpdateUserGroupAssignment(requestParameters: UserGroupAssignmentsUpdateUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserGroupAssignment> {
        const response = await this.userGroupAssignmentsUpdateUserGroupAssignmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for userGroupAssignmentsValidateCreateUserGroupAssignment without sending the request
     */
    async userGroupAssignmentsValidateCreateUserGroupAssignmentRequestOpts(requestParameters: UserGroupAssignmentsValidateCreateUserGroupAssignmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userGroupAssignmentCreate'] == null) {
            throw new runtime.RequiredError(
                'userGroupAssignmentCreate',
                'Required parameter "userGroupAssignmentCreate" was null or undefined when calling userGroupAssignmentsValidateCreateUserGroupAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user_group_assignments/validate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserGroupAssignmentCreateToJSON(requestParameters['userGroupAssignmentCreate']),
        };
    }

    /**
     * Validate data for a new user group assignment without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a user group assignment
     */
    async userGroupAssignmentsValidateCreateUserGroupAssignmentRaw(requestParameters: UserGroupAssignmentsValidateCreateUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.userGroupAssignmentsValidateCreateUserGroupAssignmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for a new user group assignment without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a user group assignment
     */
    async userGroupAssignmentsValidateCreateUserGroupAssignment(requestParameters: UserGroupAssignmentsValidateCreateUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userGroupAssignmentsValidateCreateUserGroupAssignmentRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for userGroupAssignmentsValidateUpdateUserGroupAssignment without sending the request
     */
    async userGroupAssignmentsValidateUpdateUserGroupAssignmentRequestOpts(requestParameters: UserGroupAssignmentsValidateUpdateUserGroupAssignmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userGroupAssignmentId'] == null) {
            throw new runtime.RequiredError(
                'userGroupAssignmentId',
                'Required parameter "userGroupAssignmentId" was null or undefined when calling userGroupAssignmentsValidateUpdateUserGroupAssignment().'
            );
        }

        if (requestParameters['userGroupAssignmentUpdate'] == null) {
            throw new runtime.RequiredError(
                'userGroupAssignmentUpdate',
                'Required parameter "userGroupAssignmentUpdate" was null or undefined when calling userGroupAssignmentsValidateUpdateUserGroupAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user_group_assignments/{user_group_assignment_id}/validate`;
        urlPath = urlPath.replace('{user_group_assignment_id}', encodeURIComponent(String(requestParameters['userGroupAssignmentId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UserGroupAssignmentUpdateToJSON(requestParameters['userGroupAssignmentUpdate']),
        };
    }

    /**
     * Validate data for updating the given user group assignment, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate user group assignment update
     */
    async userGroupAssignmentsValidateUpdateUserGroupAssignmentRaw(requestParameters: UserGroupAssignmentsValidateUpdateUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.userGroupAssignmentsValidateUpdateUserGroupAssignmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for updating the given user group assignment, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate user group assignment update
     */
    async userGroupAssignmentsValidateUpdateUserGroupAssignment(requestParameters: UserGroupAssignmentsValidateUpdateUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userGroupAssignmentsValidateUpdateUserGroupAssignmentRaw(requestParameters, initOverrides);
    }

}
